import { ReactNode } from '@tanstack/react-router';

export const ClubInfo = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
